import React, { useState } from "react";
import { Grid, styled } from "@mui/material";
import { CustomerDTO } from "@beable/roster-backend-client-v1";
import { SiteDTO } from "@beable/roster-backend-client-v1";
import CustomerSelector from "./CustomerSelector";
import SiteSelector from "./SiteSelector";
import CustomerCard from "./CustomerCard";
import SiteCard from "./SiteCard";
import { defaultTo } from "lodash";

interface CustomerSelectorProps {
  onCustomerSelect?: any;
  onSiteSelect?: any;
  displayCustomerCard?: boolean;
  displaySiteCard?: boolean;
  preselectedCustomer?: string | undefined;
  preselectedSite?: number | undefined;
}
const initialSelectedCustomerValue: CustomerDTO | undefined = undefined;
const initialSelectedSiteValue: SiteDTO | undefined = undefined;

const StandardCustomerSelector = styled(CustomerSelector)(({ theme }) => ({
  margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
  minWidth: 120,
  width: "90%",
}));

const StandardSiteSelector = styled(SiteSelector)(({ theme }) => ({
  margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
  minWidth: 120,
  width: "90%",
}));

export default function CustomerAndSiteSelector(props: CustomerSelectorProps) {
  const [selectedCustomer, setSelectedCustomer] = useState(
    initialSelectedCustomerValue
  );
  const [selectedSite, setSelectedSite] = useState(initialSelectedSiteValue);

  const displaySiteCard = defaultTo(props.displaySiteCard, true);
  const displayCustomerCard = defaultTo(props.displayCustomerCard, true);

  const handleCustomerChange = (customer: CustomerDTO | undefined) => {
    if (!selectedCustomer || customer?.id !== selectedCustomer.id) {
      setSelectedCustomer(customer);
      handleSiteChange(undefined);
      if (props.onCustomerSelect && customer) {
        props.onCustomerSelect(customer);
      }
    }
  };

  const handleSiteChange = async (site: SiteDTO | undefined) => {
    setSelectedSite(site);
    if (props.onSiteSelect) {
      props.onSiteSelect(site);
    }
  };

  const getCustomerId = () => {
    return props.preselectedCustomer ?? undefined;
  };

  const getSiteId = () => {
    return props.preselectedSite ?? undefined;
  };

  return (
    <Grid size={12}>
      <StandardCustomerSelector
        onSelect={handleCustomerChange}
        customerId={getCustomerId()}
      />
      {selectedCustomer && selectedCustomer.id && displayCustomerCard && (
        <Grid sx={{ width: "90%", marginLeft: '16px' }} size={12}>
          <CustomerCard customer={selectedCustomer} />
        </Grid>
      )}
      {selectedCustomer && (
        <Grid size={12}>
          <StandardSiteSelector
            onSelect={handleSiteChange}
            customerId={selectedCustomer?.id ?? ""}
            siteId={getSiteId()}
          />
        </Grid>
      )}
      {selectedSite && selectedSite.id && displaySiteCard && (
        <Grid sx={{ width: "90%", marginLeft: '16px' }} size={12}>
          <SiteCard site={selectedSite} />
        </Grid>
      )}
    </Grid>
  );
}
